/* global angular */
require("angular");
require("./lib/angular-animate/angular-animate.min");

module.exports = angular.module("photo-test", ["ngAnimate"]);